import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let active = true;
    const poll = async (attempt = 0) => {
      if (!active || attempt >= 8) { if (attempt >= 8) setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setTries(attempt + 1);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => poll(attempt + 1), 2500);
      } catch {
        setTimeout(() => poll(attempt + 1), 2500);
      }
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        {status === "polling" && (
          <>
            <CircleNotch size={64} className="mx-auto text-orange-500 animate-spin" />
            <h1 className="font-display text-3xl font-black mt-6">Vérification du paiement...</h1>
            <p className="text-stone-500 mt-2">Tentative {tries}/8</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={80} weight="fill" className="mx-auto text-emerald-500" />
            <h1 className="font-display text-3xl font-black mt-6" data-testid="payment-success">Paiement réussi ! 🎉</h1>
            <p className="text-stone-600 mt-3">Vos étiquettes seront imprimées et expédiées sous 5 jours ouvrés.</p>
            <Link to="/dashboard"><Button className="mt-6 bg-orange-500 hover:bg-orange-600 rounded-full font-bold">Retour au dashboard</Button></Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle size={80} weight="fill" className="mx-auto text-rose-500" />
            <h1 className="font-display text-3xl font-black mt-6">Paiement non confirmé</h1>
            <p className="text-stone-600 mt-3">Si vous avez été débité, contactez-nous. Sinon réessayez.</p>
            <Link to="/dashboard"><Button className="mt-6 rounded-full" variant="outline">Retour</Button></Link>
          </>
        )}
      </div>
    </Layout>
  );
}
